import '../App.css';
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { useMemo, useState} from "react";
import main_Logo from '../assets/images/logo.png';
import Logo from '../assets/images/brainium.png';
import background from "../assets/images/banner-bg.jpeg";
import Logo3 from '../assets/images/leadorchard.png';
import Logo4 from '../assets/images/rishabh.png';
import Logo5 from '../assets/images/technolabs.png';
import Logo6 from '../assets/images/tinkerly.png';
import { useNavigate } from 'react-router-dom';
import { time } from './slice';
import { useDispatch, useSelector } from 'react-redux';

function HireTalent4() {
  const [role, setRole] = useState({});
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const data = useSelector((state)=> state.reducerApp.timeing)
  const hiring_data = useSelector((state) => state.reducerApp.hiring)


  const keys = useMemo(() => {
    const keysArray = Object.keys(hiring_data);
    const filteredKeysArray = keysArray.filter(key => hiring_data[key] !== false);
    return filteredKeysArray
  },[hiring_data])

  const prevButton = () => {
    navigate('/HireTalent3')
  }

  const nextButton = () => {
    if(data!==''){
      navigate('/HireTalent5') 
    }
  }

  const handleChange = (e,value) =>{
    const type=e.target.value
    setRole(type)
    dispatch(time(type))
  }

  const hire_talent_bg = {
    backgroundImage: `url(${background})`,
    height: '100vh',
    width: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };

  return (
    <>
      <div className='hire_talent_wrapper'>
        <Row>
          <Col md={7} xs={12}>
            <div className="hire_talent_content">
              <Container>
                <div className="top_head text-center">
                  <img src={main_Logo} alt="Logo" />
                  <h4>Thank you for your interest in RubyPy.</h4>
                  <p>We do not yet offer top talent in India</p>
                </div>
                <Row className='card_padding'>

                  <Card.Body>
                    <Form.Label className="head_title">How long do you need the {keys.join(', ')} ?</Form.Label>
                    <div>
                    <Form.Group controlId="Less than 1 week">
                      <Form.Check
                        type="radio"
                        label='Less than 1 week'
                        name="radioGroup"
                        onChange={(e) => handleChange(e,e.target.value)}
                        value='Less than 1 week'
                        checked={data === 'Less than 1 week'}
                      />
                      </Form.Group>
                      <Form.Group controlId="1 to 4 weeks">
                      <Form.Check
                        type="radio"
                        label='1 to 4 weeks'
                        name="radioGroup"
                        onChange={(e) => handleChange(e,e.target.value)}
                        value='1 to 4 weeks'
                        checked={data === '1 to 4 weeks'}
                      />
                      </Form.Group>
                      <Form.Group controlId="1 to 3 months">
                      <Form.Check
                        type="radio"
                        label='1 to 3 months'
                        name="radioGroup"
                        onChange={(e) => handleChange(e,e.target.value)}
                        value='1 to 3 months'
                        checked={data === '1 to 3 months'}
                      />
                      </Form.Group>
                      <Form.Group controlId="3 to 6 months">
                      <Form.Check
                        type="radio"
                        label='3 to 6 months'
                        name="radioGroup"
                        onChange={(e) => handleChange(e,e.target.value)}
                        value='3 to 6 months'
                        checked={data === '3 to 6 months'}
                      />
                      </Form.Group>
                      <Form.Group controlId="Longer than 6 months">
                      <Form.Check
                        type="radio"
                        label='Longer than 6 months'
                        name="radioGroup"
                        onChange={(e) => handleChange(e,e.target.value)}
                        value='Longer than 6 months'
                        checked={data === 'Longer than 6 months'}
                      />
                      </Form.Group>
                      <Form.Group controlId="I will decide later">
                      <Form.Check
                        type="radio"
                        label='I will decide later'
                        name="radioGroup"
                        onChange={(e) => handleChange(e,e.target.value)}
                        value='I will decide later'
                        checked={data === 'I will decide later'}
                      />
                      </Form.Group>
                    </div>
                  </Card.Body>
                  <Card.Footer className="d-flex justify-content-between">
                    <Button onClick={prevButton}>Previous</Button>
                    <Button onClick={nextButton} disabled={data===''}>Next</Button>
                  </Card.Footer>
                </Row>
              </Container>
            </div>
          </Col>
          <Col md={5} xs={12}>
            <div className="hire_talent_right_wrapper" style={hire_talent_bg}>
              <div className="hire_talent_logo">
                <div>
                  <h3>TRUSTED BY</h3>
                  <ul>
                    <li><img src={Logo} alt="fire icon" /></li>
                    <li><img src={Logo3} alt="fire icon" /></li>
                    <li><img src={Logo4} alt="fire icon" /></li>
                    <li><img src={Logo5} alt="fire icon" /></li>
                    <li><img src={Logo6} alt="fire icon" /></li>
                    <li><img src={Logo} alt="fire icon" /></li>
                    <li><img src={Logo3} alt="fire icon" /></li>
                    <li><img src={Logo4} alt="fire icon" /></li>
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>



  );
}

export default HireTalent4;